import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the UAT environment (`admin.uat.wisesys.info`)
 */
export const uatServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.uat.wisesys.info',
    auroraApiServer: 'https://uat.aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://l8e0mz5odb.execute-api.us-east-1.amazonaws.com/uat',
    equipment: 'https://services-uat.us.wisesys.info',
    socketServer: 'wss://uat.socket.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket-uat.us.wisesys.info',
    auroraServer: 'https://uat-api.aurora-v2.wisesys.info',
    environment: ServerEnvironment.UAT,
    CIEnv: ServerCIEnvironment.UAT,
    vehicleProfile:
        'https://z9fgl5xulh.execute-api.us-east-1.amazonaws.com/uat',
    routePathGeometryServer:
        'https://u0dlfowfi9.execute-api.us-east-1.amazonaws.com/uat',
    configurableWorkflowServer:
        'https://ksjgorzu2k.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://z7axlvyzo1.execute-api.us-east-1.amazonaws.com/uat',
    bannerService: 'https://vv908w5jte.execute-api.us-east-1.amazonaws.com/uat'
};
